function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.615 6.6374L22.8275 4.8374C22.715 4.6124 22.49 4.4999 22.265 4.3874L16.19 3.1499L12.815 1.3499C12.2525 1.0124 11.24 0.899902 11.015 0.899902H6.74001C6.06501 0.899902 5.05251 1.4624 4.60251 1.6874C4.15251 2.0249 3.14001 2.8124 2.80251 3.1499L1.11501 3.5999C0.777511 3.7124 0.552511 3.9374 0.552511 4.2749V5.3999H0.890011C1.34001 5.3999 1.67751 5.7374 1.67751 6.1874C1.67751 6.6374 1.34001 6.9749 0.890011 6.9749H0.440011L0.102511 8.6624C-0.00998851 8.9999 0.327511 9.4499 0.665011 9.4499L3.02751 9.8999V9.8999C3.02751 8.3249 4.37751 6.9749 5.95251 6.9749C7.52751 6.9749 8.87751 8.3249 8.87751 9.8999H14.7275C14.7275 8.3249 16.0775 6.9749 17.6525 6.9749C19.2275 6.9749 20.5775 8.3249 20.5775 9.8999H22.8275C23.2775 9.8999 23.615 9.5624 23.615 9.1124V6.9749C23.615 6.8624 23.615 6.7499 23.615 6.6374Z",
  fill: "#EDA006"
});
var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 5.8,
  cy: 9.3,
  r: 1.3,
  fill: "#EDA006"
});
var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 17.3,
  cy: 9.3,
  r: 1.3,
  fill: "#EDA006"
});
function SvgCarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 11,
    viewBox: "0 0 24 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarIcon);
export default __webpack_public_path__ + "static/media/car-icon.00fea644.svg";
export { ForwardRef as ReactComponent };